// src/services/oz.ts
import { extendZodWithOpenApi } from "@asteasolutions/zod-to-openapi";
import { z } from "zod";
extendZodWithOpenApi(z);

// src/services/optional-zod-schema-defaults-builder.ts
function buildOptionalZodSchemaDefaults(schema, defaultOverrides = {}) {
  return schema.parse(defaultOverrides);
}

// src/types/zod-error.ts
import { ZodError } from "zod";
export {
  ZodError,
  buildOptionalZodSchemaDefaults,
  z as oz
};
